export const isAppleDevice = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent || '';
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1);
    const isSafari = /Safari/.test(ua) && !/Chrome|CriOS|FxiOS|Edg/.test(ua);
    const isMacSafari = /Macintosh/.test(ua) && isSafari;
    return isIOS || isMacSafari;
};

export const isPlayReadySupported = (): boolean => {
  // Check if we're in a browser environment
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }

  // Check if EME API is supported
  if (!navigator.requestMediaKeySystemAccess) {
    return false;
  }

  // Check if we're on a browser that actually supports PlayReady
  const userAgent = navigator.userAgent || '';
  const isXbox = /Xbox/.test(userAgent);
  const isEdge = /Edg/.test(userAgent);
  const isIE = /Trident|MSIE/.test(userAgent);
  const isWindows = /Windows/.test(userAgent);
  
  // PlayReady is only supported on Windows with Microsoft browsers or Xbox
  // Edge on macOS does NOT support PlayReady, only Edge on Windows does
  // Chrome on any platform uses Widevine, not PlayReady
  return isXbox || ((isEdge || isIE) && isWindows);
};

/**
 * Detects if the current browser is Chrome 64+ on macOS, Windows.
 * Persistent license caching for Widevine only works on these specific browsers
 * @returns true if Chrome 64+ on macOS/Windows/Android, false otherwise
 *
 * IMPORTANT UPDATE: Temporarily disabled everywhere, since there are some issues with persistent licenses on web.
 * Specifically, sometimes the page needs to be reloaded multiple times before playback works.
 * We don't know why yet, and have no time to investigate.
 */
export const supportsWidevinePersistentLicenses = (): boolean => {
  // TODO: Re-enable once issues are resolved
  return false;

  // Check if we're in a browser environment
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent || '';
  
  // Check if it's Chrome (not Chromium-based browsers like Edge)
  const isChromeMatch = userAgent.match(/Chrome\/(\d+)/);
  if (!isChromeMatch) {
    return false;
  }
  
  // Make sure it's not Edge, Opera, or other Chromium-based browsers
  if (/Edg|OPR|Opera/.test(userAgent)) {
    return false;
  }
  
  // Extract Chrome version
  const chromeVersion = parseInt(isChromeMatch[1], 10);
  if (chromeVersion < 64) {
    return false;
  }
  
  // Check if it's macOS, Windows, or Android
  const isMacOS = /Mac OS X|Macintosh/.test(userAgent);
  const isWindows = /Windows/.test(userAgent);

  // Tested on Android, with mixed results. Sometimes it works, sometimes it doesn't.

  return isMacOS || isWindows;
};